import classnames from 'classnames';
import { withFormsy } from 'formsy-react';

import CodeEditor from "@Components/CodeEditor"

function CodeEditorFormsy({ getErrorMessage, isValid, isPristine, isRequired, getValue, setValue, onChange, className, ...props }) {
  const value = getValue()
  const invalid = !isValid() && !isPristine()

  className = classnames({
    'w-full': true,
    'h-[30vh]': true,
    'form-control': true,
    'border-2': invalid,
    'twy-border-danger': invalid,
    'is-invalid': invalid,
  }, className)

  const handleChange = value => {
    setValue(value);
    onChange && onChange(value)
  }

  return <>
    <div className={`codeeditor ${invalid && 'is-invalid'}`}>
      <CodeEditor
        onChange={handleChange}
        {...props}
        {...{ value, className }}
      />
    </div>
    <span className="invalid-feedback">
      {getErrorMessage()}
      {isRequired() && !value && ' Field required'}
    </span>
  </>
}

export default withFormsy(CodeEditorFormsy);
